import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import {
  PanesComponent as Panes,
  WebinarInfoPaneComponent,
  WebinarUserInfoPaneComponent,
} from '../../../sharedLegacy/components'
import {
  isExternalFeedConnectionType,
  useConnectInfoQuery,
} from '../../../global/blocs/useConnectInfo'
import { NoticesBanner } from '../../../Layout/Notices/NoticesBanner'
import { WebinarConnectionDetails } from '../WebinarAppComponent/WebinarConnectionDetails'

/**
 * Container
 */
const Container = styled.div`
  align-items: center;
  background-attachment: fixed;
  background-color: #222222;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100%;
`

/**
 * PanesContainer
 */
const PanesContainer = styled.div`
  background-color: #ffffff;
  border-radius: 2px;
  height: 460px;
  padding: 16px;
  width: 750px;
`

const getWebinarStatus = (isDraft, liveStatus, isBroadcasting) => {
  if (!isDraft && liveStatus === 'upcoming') {
    return 'upcoming'
  }

  if (!isDraft && liveStatus === 'live') {
    if (!isBroadcasting) {
      return 'upcoming'
    }

    return 'live'
  }

  return 'draft'
}

const FoyerPanes = {
  WebinarInfo: 0,
  UserInfo: 1,
}

/**
 * WebinarFoyerComponent
 */
const WebinarFoyerComponent = ({ renderOptions }) => {
  const { data: webinarConnectInfo } = useConnectInfoQuery()

  const numberOfPanes = Object.keys(FoyerPanes).length

  const status = getWebinarStatus(
    webinarConnectInfo?.draft_p,
    webinarConnectInfo?.live_status,
    webinarConnectInfo?.broadcasting_p
  )

  return (
    <Container>
      <NoticesBanner />
      <PanesContainer>
        <Panes
          numberOfPanes={numberOfPanes}
          direction="row"
          renderPane={(index) => {
            if (index === FoyerPanes.WebinarInfo) {
              return (
                <WebinarInfoPaneComponent
                  title={webinarConnectInfo?.name ?? ''}
                  description={webinarConnectInfo?.description_html ?? ''}
                  status={status}
                  speakers={webinarConnectInfo?.speakers ?? []}
                  canDisableSpeakers
                />
              )
            }

            if (index === FoyerPanes.UserInfo) {
              const connectionType = webinarConnectInfo?.connection_type
              const isExternalStream =
                isExternalFeedConnectionType(connectionType)

              return (
                <WebinarUserInfoPaneComponent
                  name={webinarConnectInfo?.connect_name ?? ''}
                  avatarUrl={webinarConnectInfo?.connect_avatar_url ?? null}
                >
                  {isExternalStream && (
                    <WebinarConnectionDetails
                      streamingServerUrl={
                        webinarConnectInfo?.connection_details_url
                      }
                      streamKey={
                        webinarConnectInfo?.connection_details_stream_key
                      }
                      connectionType={connectionType}
                    />
                  )}
                  {webinarConnectInfo?.webrtc_role &&
                    renderOptions &&
                    renderOptions(
                      webinarConnectInfo.webrtc_role,
                      webinarConnectInfo.connect_presenter_link
                    )}
                </WebinarUserInfoPaneComponent>
              )
            }

            return null
          }}
        />
      </PanesContainer>
    </Container>
  )
}

WebinarFoyerComponent.propTypes = {
  renderOptions: PropTypes.func,
}

// eslint-disable-next-line import-x/no-default-export
export default WebinarFoyerComponent
